import Vue from 'vue';
import PortalVue from 'portal-vue';
Vue.use(PortalVue);

Vue.component('modal', {
  template: `
    <transition name="modal" mode="out-in">
      <slot></slot>
    </transition>
  `
});
